import { createContext } from "react"

export interface LegalAndRegTextInterface {
  _id: string,
  title: string;
  image: string;
  createdAt: string,
}

export const DefaultLegalAndRegTextInterface: LegalAndRegTextInterface =  {
  _id: "",
  title: "",
  image: "",
  createdAt: "",
}


export interface ShowLegalAndRegTextsInterface {
  showSuccessMsg: boolean,
  setShowSuccessMsg: (showSuccessMsg: boolean) => void,
  showAddModal: boolean,
  setShowAddModal: (showAddModal: boolean) => void,
  showEditModal: boolean,
  setShowEditModal: (showEditModal: boolean) => void,
  showDeleteModal: boolean, 
  setShowDeleteModal: (showDeleteModal: boolean) => void,
  selectedLegalAndRegText:LegalAndRegTextInterface,
  setSelectedLegalAndRegText: (selectedLegalAndRegText:LegalAndRegTextInterface) => void,
  selectedDoctor: any,
  setSelectedDoctor: (selectedDoctor: any) => void,
  hideDataLegalAndRegText: boolean,
  setHideDataLegalAndRegText: (hideDataLegalAndRegText: boolean) => void,
  showDocumentsModal: boolean, setShowDocumentsModal: (showDocumentsModal: boolean) => void,
}

export const DefaultShowLegalAndRegTextsInterface:ShowLegalAndRegTextsInterface = {
  showSuccessMsg: false,
  setShowSuccessMsg: () => {},
  showAddModal: false,
  setShowAddModal: () => {},
  showEditModal: false,
  setShowEditModal: () => {},
  showDeleteModal: false, 
  setShowDeleteModal: () => {},
  selectedLegalAndRegText: DefaultLegalAndRegTextInterface,
  setSelectedLegalAndRegText: () => {},
  selectedDoctor: {},
  setSelectedDoctor: () => {},
  hideDataLegalAndRegText: false,
  setHideDataLegalAndRegText: () => {},
  showDocumentsModal: false, setShowDocumentsModal: () => {},
}

export const ShowLegalAndRegTextsContext = createContext(DefaultShowLegalAndRegTextsInterface)


export interface DataLegalAndRegTextInterface {
  title: string, setTitle: (title: string) => void,
  image: File | any, setImage: (image: File | any) => void,
}

export const DefaultDataLegalAndRegTextInterface: DataLegalAndRegTextInterface = {
  title: "", setTitle: () => {},
  image: null, setImage: () => {},
}

export const DataLegalAndRegTextContext = createContext(DefaultDataLegalAndRegTextInterface)
